import LoginApp from './LoginApp.svelte';
import 'bootstrap/dist/css/bootstrap.min.css';

const app = new LoginApp({
	target: document.body,
	props: {
		name: 'Authentification'
	}
});

export default app;